<template>
<span>
	<b-row cols="12" style="position: sticky; top: 0; position:relative; margin-bottom:125pt;">
		
		<b-col>
			
			<b-navbar
            		toggleable="lg"
            		type="light"
				fixed="top"
				style="-webkit-box-shadow: 0 4px 6px -6px #222;  -moz-box-shadow: 0 4px 6px -6px #222;  box-shadow: 0 4px 6px -6px #222;background:#FFFFFF;">

				<b-navbar-brand :to="{name:'home'}" variant="dark">

					<b-img 
						:src="require('../../assets/logos/PTLogo-Cropped-1.png')"
						class="img-fluid"
						style="max-width: 7.5rem"/>

				</b-navbar-brand>

				<b-navbar-toggle target="nav-collapse" />

				<b-collapse
					id="nav-collapse"
					
					is-nav>

						

					<b-navbar-nav 
						:fill="true"
						class="ml-auto text-justify">

						<!-- <b-button-group size="lg">
						
							<b-button 
								type="button"
								variant="white"
								:to="{name:'features4'}">Features</b-button>

							<b-button 
								type="button"
								variant="white"
								:to="{name:'tour4'}">Tour</b-button>

							<b-button 
								type="button"
								variant="white"
								:to="{name:'pricing4'}">Pricing</b-button>

							<b-button 
								type="button"
								variant="white"
								:to="{name: 'signup', params: {action: 'signup'}}">Sign up</b-button>

							<b-button 
								type="button"
								variant="white"
								:to="{name: 'signup', params: {action: 'signin'}}">Sign in</b-button>

						</b-button-group> -->

						<b-nav-item 
							class="h5"
							:to="{name:'features4'}">Features</b-nav-item>

						<b-nav-text class="d-none d-sm-block" style="color:lightgrey"> | </b-nav-text>

						<b-nav-item 
							class="h5"
							:to="{name:'tour4'}">Tour</b-nav-item>

						<b-nav-text class="d-none d-sm-block" style="color:lightgrey"> | </b-nav-text>

						<b-nav-item 
							class="h5"
							:to="{name:'pricing4'}">Pricing</b-nav-item>

						<b-nav-text class="d-none d-sm-block" style="color:lightgrey"> | </b-nav-text>

						<b-nav-item 
							class="h5"
							:to="{name:'gallery-public'}">Gallery</b-nav-item>

						<b-nav-text class="d-none d-sm-block" style="color:lightgrey"> | </b-nav-text>
						
						<b-nav-item 
							class="h5"
							:to="{name: 'signup', params: {action: 'signup'}}">Sign up</b-nav-item>

						<b-nav-text class="d-none d-sm-block" style="color:lightgrey"> | </b-nav-text>

						<b-nav-item 
							class="h5"
							:to="{name: 'signup', params: {action: 'signin'}}">Sign in</b-nav-item>

						

					</b-navbar-nav>

				</b-collapse>
			
			</b-navbar>

			
		</b-col>
	</b-row>
</span>
</template>

<script>
export default {
	methods: {
		login(goTo) {
        
        		let uri = ''

        		if(goTo) {

          		uri = window.location + goTo

        		} else {
          		uri = window.location.origin
        		}

        		this.$auth.loginWithRedirect({
          		redirect_uri: uri
        		});
		},
	}
}
</script>